
const hpBrandsSkeleton = () => {
    try {
        const skeleton = document.querySelector('.js-hp-brands-skeleton')
        try {
            const el = document.createElement('div')
            el.classList.add('skeleton-loader')
            el.style.marginBottom = '10px'
            el.style.height = '350px'
            skeleton.appendChild(el)
        } catch (e) {
            console.log(e)
        }
    } catch (e) {
        console.log(e)
    }
}

hpBrandsSkeleton()